import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/feature/Reveal';
import { openSupportChat } from '@/utils/supportChat';
import { deliverables } from '@/mocks/deliverables';

export default function FinalCta() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-shell mx-auto">
          <Reveal>
            <SectionHeading
              eyebrow="What lands in your hands"
              title="You get the whole kit, not just a file"
              subtitle="Every trader receives the same four things — the EA, a preset matched to your balance, a setup guide and every future update. All of it free."
            />
          </Reveal>

          <div className="mt-10 md:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {deliverables.map((item, index) => (
              <Reveal key={item.id} delay={index * 70}>
                <div className="h-full rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 hover:border-accent-300 transition-colors duration-200">
                  <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-950 text-accent-400">
                    <i className={`${item.icon} text-2xl`} aria-hidden="true"></i>
                  </span>
                  <h3 className="mt-4 font-heading text-sm md:text-base font-semibold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600">{item.text}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={160}>
            <div className="relative mt-8 md:mt-10 overflow-hidden rounded-lg bg-primary-950 px-6 py-10 md:px-14 md:py-12">
              <div
                className="absolute -right-24 -top-24 w-72 h-72 rounded-full bg-accent-500/15 blur-3xl"
                aria-hidden="true"
              ></div>
              <div
                className="absolute -left-16 -bottom-24 w-64 h-64 rounded-full bg-primary-500/20 blur-3xl"
                aria-hidden="true"
              ></div>

              <div className="relative flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
                <div className="max-w-2xl">
                  <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-3.5 py-1.5 text-[11px] font-semibold uppercase tracking-[0.16em] text-accent-300">
                    <span className="w-1.5 h-1.5 rounded-full bg-accent-400" aria-hidden="true"></span>
                    Free forever
                  </span>
                  <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-background-50 text-balance">
                    Get the EA free — just ask in the chat
                  </h2>
                  <p className="mt-4 text-sm md:text-base leading-relaxed text-background-200/85">
                    Tell us your broker, account size and platform in the support chat. We send back the
                    EA file and a matching risk preset, usually within a few minutes. No payment, no
                    subscription, no upsell.
                  </p>
                </div>

                <div className="shrink-0 w-full sm:w-auto">
                  <button
                    type="button"
                    onClick={openSupportChat}
                    className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-accent-500 hover:bg-accent-400 px-8 py-3.5 text-sm md:text-base font-semibold text-primary-950 transition-all duration-200 hover:-translate-y-0.5 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-customer-service-2-line text-lg" aria-hidden="true"></i>
                    Chat to get the EA
                  </button>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}